import { useQuery } from "@apollo/client/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { publicClient } from "@/graphql/public-client";
import { PublicShareItemsDocument } from "@/graphql/generated/public";
import { Button } from "@/components/design/Button";
import { ShareLandingLayout } from "./ShareLandingLayout";

export function PublicSharePage() {
  const [cursors, setCursors] = useState<(string | null)[]>([null]);
  const [idx, setIdx] = useState(0);
  const { data, loading, error, refetch } = useQuery(PublicShareItemsDocument, {
    client: publicClient, variables: { after: cursors.at(-1) },
  });
  const page = data?.publicListings;
  const list = page?.nodes ?? [];
  const go = (delta: number) => setIdx(value => list.length ? (value + delta + list.length) % list.length : 0);
  return <ShareLandingLayout publicView mode="new" selectMode={() => {}} list={list} idx={idx}
    setIdx={setIdx} go={go} loading={loading} error={error}>
    {error && <Button id="public-share-retry" variant="secondary" onClick={() => void refetch()}><FormattedMessage id="share.public.retry" /></Button>}
    <div className="mt-6 flex justify-between gap-4">
      {cursors.length > 1 && <Button id="public-share-prev" variant="secondary" disabled={loading} onClick={() => { setIdx(0); setCursors(value => value.slice(0,-1)); }}><FormattedMessage id="common.prevPage" /></Button>}
      {!error && page?.pageInfo.hasNextPage && page.pageInfo.endCursor && <Button id="public-share-next" variant="secondary" disabled={loading} onClick={() => { setIdx(0); setCursors(value => [...value, page.pageInfo.endCursor ?? null]); }}><FormattedMessage id="common.nextPage" /></Button>}
    </div>
  </ShareLandingLayout>;
}
